module.exports = __webpack_public_path__ + "static/media/tree-step-2_2.67c6aafc.svg";